import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { addArticleExpenditures, setAddArticleExpenditures } from '../../action/handbook';
import cn from 'classnames';
import ErrorContainer from '../utils/ErrorContainer';
import Select from 'react-select';
import { optionsTransaction } from '../../constants/app';

class AddArticleExpenditures extends Component {
    componentWillUnmount() {
        this.props.setAddArticleExpenditures({});
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Добавить статью расхода</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/articlesExpenditures')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidArticleExpenditures() {
        const { name, typeTransaction } = this.props.addForm;
        if (name && typeTransaction ) return true;
        
        return false;
    }

    setArticleExpenditures = (field) => (e) => {
        const data = {...this.props.addForm};
        if(field === 'name') {
            data[field] = e.target.value;
        } else {
            data[field] = e.value;
        }

        this.props.setAddArticleExpenditures(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addArticleExpenditures(this.props.addForm).then(result => {
            if (result) {
                this.props.history.push('/handbook/articlesExpenditures');
            }
        });
    }    

    render() {
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">  
                            <div className="row">
                                <div className="col-md-6">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setArticleExpenditures('name')}
                                        value={this.props.addForm.name}
                                        placeholder="Название..."
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>{"Тип транзакции *"}</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={optionsTransaction.find((option) => option.value === this.props.addForm.typeTransaction)}
                                        onChange={this.setArticleExpenditures('typeTransaction')}
                                        placeholder="Тип транзакции"
                                        options={optionsTransaction}
                                        noOptionsMessage={() => 'Нет типов'}
                                    />
                                </div>                                
                            </div>                          
                        </div>
                        <ErrorContainer field="addArticleExpenditures" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidArticleExpenditures() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Добавить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    addForm: state.handbook.add,
    loading: state.loaders.addArticleExpenditures
});

const mapDispatchToProps = {
    setAddArticleExpenditures: (data) => setAddArticleExpenditures(data),
    addArticleExpenditures: (data) => addArticleExpenditures(data)
}

export default connect(mapStateToProps, mapDispatchToProps)(AddArticleExpenditures);